import Swiper from 'swiper';
import { EffectFade, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initTab(element) {
    const listTabs = Array.from(element.querySelectorAll('.swiper-pagination button')).map(function (element) {
        return element.textContent || element.innerText;
    });

    const swiper = new Swiper(element.querySelector('.swiper-tabs'), {
        modules: [Pagination, EffectFade],
        speed: 500,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<button class="whitespace-nowrap block text-2xl font-normal text-white underline-offset-8 hover:font-medium hover:text-secondaryLight hover:underline md:text-3xl [&.swiper-pagination-bullet-active]:text-secondaryLight [&.swiper-pagination-bullet-active]:underline ' +
                    className +
                    '">' +
                    listTabs[index] +
                    '</button>'
                );
            },
        },
    });
}

function initAllTabs() {
    document.querySelectorAll('.tabsContent').forEach(function (element) {
        initTab(element);
    });
}

domContentLoadEvent(initAllTabs);
